import React from "react";
import "./BookmarkList.css";

const BookmarkList = ({
  bookmarks,
  loading,
  onBookmarkClick,
  onBookmarkDelete,
}) => {
  const handleDeleteBookmark = (e, bookmarkId) => {
    e.stopPropagation();
    if (onBookmarkDelete) {
      onBookmarkDelete(bookmarkId);
    }
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  if (loading) {
    return <div className="bookmarks-loading">Loading bookmarks...</div>;
  }

  if (!bookmarks || bookmarks.length === 0) {
    return <div className="no-bookmarks">No bookmarks for this content</div>;
  }

  return (
    <div className="bookmarks-container">
      <h3>Bookmarks</h3>
      <ul className="bookmarks-list">
        {bookmarks.map((bookmark) => (
          <li
            key={bookmark.id}
            className="bookmark-item"
            onClick={() => onBookmarkClick(bookmark.timestamp)}
          >
            <div className="bookmark-time">
              {formatTime(bookmark.timestamp)}
            </div>
            <div className="bookmark-note">
              {bookmark.subtitle_text || "No note"}
            </div>
            <div className="bookmark-subtitle">
              {bookmark.subtitle ? bookmark.subtitle.text : ""}
            </div>
            <button
              className="delete-bookmark-button"
              onClick={(e) => handleDeleteBookmark(e, bookmark.id)}
            >
              ✕
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BookmarkList;
